import DOMPurify from "dompurify";

const BLOCKED_TAGS = [
    "script",
    "iframe",
    "object",
    "embed",
    "form",
    "input",
    "button",
    "textarea",
    "select",
    "link",
    "meta",
];

const BASE_CONFIG = {
    USE_PROFILES: { html: true },
    FORBID_TAGS: BLOCKED_TAGS,
    ADD_ATTR: ["class", "style", "data-ref", "data-page", "target"],
    ALLOW_DATA_ATTR: true,
};

const sanitizeUrl = (url) => {
    if (!url) return url;
    const value = String(url).trim().toLowerCase();
    const blockedProtocols = [/^java\s*script:/, /^data:/, /^vbscript:/];
    if (blockedProtocols.some((protocol) => protocol.test(value))) {
        return "";
    }
    return url;
};

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (!node || !node.attributes) return;

    for (const attr of Array.from(node.attributes)) {
        if (/^on/i.test(attr.name)) {
            node.removeAttribute(attr.name);
        }
    }

    if (node.hasAttribute("href")) {
        const href = sanitizeUrl(node.getAttribute("href"));
        if (href) {
            node.setAttribute("href", href);
            if (node.getAttribute("target") === "_blank") {
                node.setAttribute("rel", "noopener noreferrer");
            }
        } else {
            node.removeAttribute("href");
        }
    }

    if (node.hasAttribute("src")) {
        const src = sanitizeUrl(node.getAttribute("src"));
        if (src) {
            node.setAttribute("src", src);
        } else {
            node.removeAttribute("src");
        }
    }
});

export const sanitizeHtml = (html, options = {}) => {
    if (!html) return "";
    return DOMPurify.sanitize(String(html), {
        ...BASE_CONFIG,
        ...options,
    });
};

export const safeHtml = (html, options = {}) => ({
    __html: sanitizeHtml(html, options),
});
